import {
    ACTIVATE_SERVICE_LOADING,
    ACTIVATE_SERVICE_FAILED,
    ACTIVATE_SERVICE_SUCCESS
    } from "../types"
    
    const initialState = {
      loading: false,
      error: false,
      message: null,
    }
    
    export default function (state = initialState, action) {
      switch (action.type) {
        case ACTIVATE_SERVICE_LOADING:
          return {
            ...state,
            loading: true,
            error: false,
            message: null,
          }
        case ACTIVATE_SERVICE_FAILED:
          return {
            ...state,
            loading: false,
            error: true,
            message: action.payload,
          }
        case ACTIVATE_SERVICE_SUCCESS:
          return {
            ...state,
            loading: false,
            error: false,
            message: null,
          }
        default:
          return state
      }
    }